import axios from "axios";
import { API_URL } from "../../config";
import { getToken } from "../../utils/authManager";

export const followUnfollow = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}follower/${id}`, null,{
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const fetchFollowers = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}follower/followers`, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const fetchFollowing = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}follower/following`, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
